import { render, staticRenderFns } from "./metaDataSelectItem.vue?vue&type=template&id=884eb018&"
import script from "./metaDataSelectItem.vue?vue&type=script&lang=js&"
export * from "./metaDataSelectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/common/metaDataSelectItem.vue"
export default component.exports